import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { chipsExcessProps, chipsExcessEmits } from './chipsBoxExcess';
import { Teleport as vTeleport, type TooltipBinding } from '../../directives';
import { UiIconClose } from '../../icons';


const __default__ = {
    name: 'UiChipsExcess',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: chipsExcessProps,
  emits: chipsExcessEmits,
  setup(__props, { emit: emits }) {

const props = __props




const excessRef = ref();

const excessCount = computed<number>(() => Math.max(0, props.chips.length - props.max));
const excessChips = computed<string[]>(() => props.chips.slice(props.max));

const tooltipParams = computed<TooltipBinding>(() => ({
    ref: excessRef.value,
    hover: true,
    placement: props.placement,
    offset: 8,
    removeOnUnbind: true,
}));

return { __sfc: true,props, emits, excessRef, excessCount, excessChips, tooltipParams, vTeleport, UiIconClose }
}

})